<template>
  <div>
    <AppHeader />
    <slot />
    <AppFooter />
  </div>
</template>

<script setup>
import AppHeader from './AppHeader/AppHeader.vue';
import AppFooter from './AppFooter/AppFooter.vue';

const { hostUrl } = useRuntimeConfig().public;
const route = useRoute();

useHead({
  title: 'Proxify Developers',
  meta: [
    {
      key: 'og:title',
      property: 'og:title',
      content: 'Proxify Developers',
    },
    {
      key: 'og:image',
      property: 'og:image',
      content: '/images/og/image.png',
    },
    {
      key: 'og:description',
      name: 'description',
      property: 'og:description',
      content:
        'Fill in our single talent application for global remote jobs to get thousands of opportunities at cutting-edge companies. Your talent deserves free dedicated support for your career.',
    },
    {
      key: 'og:keywords',
      name: 'keywords',
      property: 'og:keywords',
      content:
        'Remote jobs, Global talent, Global talent jobs, Remote developer job, Remote software developer jobs, Remote programming jobs, Developer remote jobs, High paying remote developer jobs, Remote sql developer jobs',
    },
    {
      key: 'og:url',
      property: 'og:url',
      content: `${hostUrl}${route.path}`,
    },
  ],
});

onMounted(() => {
  initialPageAndSource();
  setTalentClickId();
});

function initialPageAndSource() {
  const lastLandingPage = sessionStorage.getItem('last_landing_page');
  if (!lastLandingPage) {
    sessionStorage.setItem('last_landing_page', window.location.href);
  }
  const initialPageAndSource = useCookie('initialPageAndSource', {
    path: '/',
    maxAge: 60 * 60 * 24 * 365,
  });

  if (!initialPageAndSource.value) {
    initialPageAndSource.value = {
      initialPage: window.location.href,
      initialSource: document.referrer,
    };
  }
}

function setTalentClickId() {
  const url = window.location.href;
  const match = url.match('[#?&]clickId=([^&#]+)');

  if (match) {
    const talentCookie = useCookie('talentClickId');
    talentCookie.value = match[1];
  }
}
</script>
